import authFetch from './fetch';
import { makeRequest } from './utils';

export const routes = {
  clerkingCustomersPath: () => 'api/customers?RequiresClerking=true',
  clerkingCustomerPathById: (customerId, addRemove) => `api/customers/${customerId}/clerking/${addRemove}`,
};

export const fetchClerkingCustomers = () => authFetch.get(routes.clerkingCustomersPath());

export const putClerkingCustomerById = (customerId, addRemove) =>
  authFetch.put(routes.clerkingCustomerPathById(customerId, addRemove));

export const getCustomers = async (name) =>
  makeRequest(authFetch.get(`api/customers?IsDeleted=false&Name=${name || ''}`));

export const getBillTos = async (name) =>
  makeRequest(authFetch.get(`api/customers/billtos?IsDeleted=false&Name=${name || ''}`));
